/* Marketing band before and after slider (snippets/cq-marketing-band.liquid). The range input covers the photos, so
   dragging, tapping and the arrow keys move the divider; its value is the share of the before photo shown. */
if (!customElements.get('cq-band-compare')) {
  customElements.define('cq-band-compare', class extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('.cqmb-ba-range');
      if (!range || this.dataset.ready) return;
      this.dataset.ready = '1';
      const set = () => this.style.setProperty('--cqmb-pos', `${range.value}%`);
      range.addEventListener('input', set);
      set();
    }
  });
}
